module.exports = __webpack_public_path__ + "palermo.jpg?79cbd98c42e3c52c7a626c700ad84846";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/palermo.jpg
// module id = 27
// module chunks = 0